var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#02276B",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.9142C11 10.4093 11.4093 10 11.9142 10H24.4713C24.9762 10 25.3855 10.4093 25.3855 10.9142V17.157C25.3855 17.3857 25.2001 17.5712 24.9713 17.5712C24.7426 17.5712 24.5571 17.3857 24.5571 17.157V10.9142C24.5571 10.8668 24.5187 10.8284 24.4713 10.8284H11.9142C11.8668 10.8284 11.8284 10.8668 11.8284 10.9142V25.7308C11.8284 25.7782 11.8668 25.8166 11.9142 25.8166H19.7276C19.9564 25.8166 20.1419 26.0021 20.1419 26.2308C20.1419 26.4596 19.9564 26.645 19.7276 26.645H11.9142C11.4093 26.645 11 26.2357 11 25.7308V10.9142Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9148 25.3719C28.4213 24.7155 28.7225 23.8927 28.7225 22.9995C28.7225 20.8526 26.9821 19.1121 24.8351 19.1121C22.6882 19.1121 20.9478 20.8526 20.9478 22.9995C20.9478 25.1464 22.6882 26.8868 24.8351 26.8868C25.7284 26.8868 26.5513 26.5855 27.2077 26.0791L29.1464 28.0177C29.3417 28.213 29.6583 28.213 29.8535 28.0177C30.0488 27.8225 30.0488 27.5059 29.8535 27.3106L27.9148 25.3719ZM24.8351 25.8868C26.4298 25.8868 27.7225 24.5941 27.7225 22.9995C27.7225 21.4049 26.4298 20.1122 24.8351 20.1122C23.2405 20.1122 21.9478 21.4049 21.9478 22.9995C21.9478 24.5941 23.2405 25.8868 24.8351 25.8868Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1256 13.6152C13.8968 13.6152 13.7114 13.8007 13.7114 14.0294C13.7114 14.2582 13.8968 14.4436 14.1256 14.4436H21.3561C21.5848 14.4436 21.7703 14.2582 21.7703 14.0294C21.7703 13.8007 21.5848 13.6152 21.3561 13.6152H14.1256Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1256 17.4564C13.8968 17.4564 13.7114 17.6419 13.7114 17.8706C13.7114 18.0994 13.8968 18.2848 14.1256 18.2848H19.5484C19.7772 18.2848 19.9626 18.0994 19.9626 17.8706C19.9626 17.6419 19.7772 17.4564 19.5484 17.4564H14.1256Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1256 21.2976C13.8968 21.2976 13.7114 21.483 13.7114 21.7118C13.7114 21.9406 13.8968 22.126 14.1256 22.126H16.837C17.0658 22.126 17.2512 21.9406 17.2512 21.7118C17.2512 21.483 17.0658 21.2976 16.837 21.2976H14.1256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/AboutUs.c6d2dd65e73be832a8c95467302a0ada.svg";
export { ForwardRef as ReactComponent };